
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export function Coverage() {
  const { ref: titleRef, isVisible: titleVisible } = useScrollAnimation();
  const { ref: gridRef, isVisible: gridVisible } = useScrollAnimation({ threshold: 0.1 });

  return (
    <section id="cobertura" className="py-20 bg-gray-950 relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(0,255,240,0.04),transparent_60%)]"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div ref={titleRef} className={`text-center mb-16 anim-fade-up ${titleVisible ? 'visible' : ''}`}>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Área de <strong className="text-neon-400 text-neon-glow-sm">Cobertura y Contacto</strong>
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            Brindamos <strong className="text-gray-200">soporte técnico informático</strong> en Capital Federal y toda la Zona Norte del Gran Buenos Aires
          </p>
          <div className="neon-line max-w-xs mx-auto mt-6 opacity-40"></div>
        </div>

        <div ref={gridRef} className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className={`bg-gray-900/80 rounded-none overflow-hidden border border-gray-800 h-[180px] sm:h-[280px] lg:h-[500px] anim-fade-left ${gridVisible ? 'visible' : ''}`}>
            <img 
              src="https://static.readdy.ai/image/5390af1b9222ae6e92dc7da25193e2e6/69c6d3bee088555c8e8e8a4836fd3557.png"
              alt="Servicio Técnico Informático - Reparación profesional de equipos"
              title="Servicio Técnico Informático - Soporte técnico profesional"
              width="600"
              height="500"
              className="w-full h-full object-contain object-center"
            />
          </div>

          <div className={`rounded-none overflow-hidden shadow-neon border border-neon-400/20 h-[500px] anim-fade-right ${gridVisible ? 'visible' : ''}`}>
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3285.5!2d-58.5297!3d-34.5547!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bcb4307e8f1f1d%3A0x1234567890abcdef!2sMaip%C3%BA%2018%2C%20Puente%20Saavedra%2C%20Buenos%20Aires!5e0!3m2!1ses!2sar!4v1234567890123!5m2!1ses!2sar"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Mapa de ubicación - Maipú 18, Puente Saavedra"
              aria-label="Mapa de ubicación de Servicio Técnico Informático en Maipú 18, Puente Saavedra"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}
